import { partfinitiClient } from 'core/services';
import {
  IAddProjectPricingProfileContactGroupPayload,
  IRemoveProjectPricingProfileContactGroupPayload,
  ISaveProjectPricingProfilePayload,
} from 'pricing/types';

export const addProjectPricingProfileContactGroup = async (
  payload: IAddProjectPricingProfileContactGroupPayload
) => {
  return partfinitiClient.postForm('/project/pricing-profile/add-contact-group', payload);
};

export const removeProjectPricingProfileContactGroup = async (
  payload: IRemoveProjectPricingProfileContactGroupPayload
) => {
  return partfinitiClient.postForm('/project/pricing-profile/remove-contact-group', payload);
};

export const saveProjectPricingProfile = async (payload: ISaveProjectPricingProfilePayload) => {
  return partfinitiClient.postForm('/project/pricing-profile/save', payload);
};
